// Single source of truth for every customer-facing price. Pages import from here —
// never write a dollar literal in copy. Change these numbers and every page,
// FAQ, schema, email-mirror string, and analytics value updates together.
export const PRICES = {
  letter: 29,            // Appeal Letter — one-time
  letterPlusMail: 49,    // Appeal Letter + USPS Certified Mail (Recommended)
  mailStandalone: 24,    // Certified mailing for an already-purchased letter
  followup: 29,          // Follow-up letter — one-time
  followupPlusMail: 49,  // Follow-up letter + Certified Mail
};

export const usd = (n) => `$${n % 1 ? n.toFixed(2) : n}`;

export const PRICE_COPY = {
  letter: usd(PRICES.letter),
  letterPlusMail: usd(PRICES.letterPlusMail),
  mailStandalone: usd(PRICES.mailStandalone),
  followup: usd(PRICES.followup),
  followupPlusMail: usd(PRICES.followupPlusMail),
  // Analytics conversion values (GA4 / Google Ads / Meta CAPI)
  value: {
    appeal_letter: PRICES.letter,
    letter_plus_mail: PRICES.letterPlusMail,
    followup_letter: PRICES.followup,
    followup_letter_mail: PRICES.followupPlusMail,
    mail_certified: PRICES.mailStandalone,
  },
};
